(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.localnavigationblock = window.oneadvanced.localnavigationblock || {};
    window.oneadvanced.localnavigationblock.init = function () {
        //console.log("initialising localnavigationblock...");

        var $localNav = $('.localnavigationblock');
        //console.log("$localNav is: ", $localNav);
        if (!$localNav.length) {
            $localNav = $('#local-navigation-inner').parent();
        }
        var anchorTo = $('.localnavigationblock').attr('id');
        var pageLevel = $('#local-navigation-inner').attr('data-page-level');
        var $containerClass = (pageLevel == "page-level-market" ||
            pageLevel == "page-level-company")
            ? "localnavigationblock__container--sticky" : "sticky-container";
        if (pageLevel == "page-level-myworkplace") {
            $containerClass = "localnavigationblock__container--myworkplace"
        }
        //console.log('ContainerClass: ', $containerClass);
        var localNavigationBlock = new Foundation.Sticky($localNav,
            {
                topAnchor: anchorTo,
                btmAnchor: 'footer',
                marginTop: 0,
                containerClass: `${$containerClass}`,
                stickyOn: 'small'
            });

        // Setup Magellan
        var $onPageNav = $('#on-page-navigation');
        //console.log("OPN Display: ", $onPageNav.css('display'));
        //console.log($onPageNav.css('display') != 'none');
        if ($onPageNav.css('display') != 'none') {
            var magellanNavigation = new Foundation.Magellan($onPageNav, { deepLinking: true, updateHistory: true });
        }

        // Enable Back to Top
        if (window.oneadvanced.localnavigationblock.enablebacktotop) {
            document.querySelector('#nav-back-to-top').addEventListener('click', () => {
                let top = document.body.getBoundingClientRect().top;
                window.scrollTo({ top: top, behavior: 'smooth' });
            })
        }

        // Accordion Menu
        window.oneadvanced.localnavigationblock.modal = $('.localnavigationblock__modal');
        window.oneadvanced.localnavigationblock.accordionmenu = $('#on-page-navigation');
        window.oneadvanced.localnavigationblock.accordiontoggle = window.oneadvanced.localnavigationblock.accordionmenu.find('button.submenu-toggle:first');
        window.oneadvanced.localnavigationblock.sublistid = $('.localnavigationblock__sublist').attr('id');
        window.oneadvanced.localnavigationblock.accordionhandler = function (event, element) {
            if ($(element).attr('id') == window.oneadvanced.localnavigationblock.sublistid) {
                window.oneadvanced.localnavigationblock.modal.toggleClass('localnavigationblock__modal--active');
            }
        };
        window.oneadvanced.localnavigationblock.accordionmenu.on("down.zf.accordionMenu up.zf.accordionMenu", window.oneadvanced.localnavigationblock.accordionhandler);

        // Handle click on fragment link and close Accordion
        window.oneadvanced.localnavigationblock.accordionclosehandler = function (event, element) {
            window.oneadvanced.localnavigationblock.accordiontoggle.trigger('click'); // Foundation's Responsive Menu does not expose Accordion Menu methods: https://github.com/foundation/foundation-sites/issues/11769
        };
        var $fragmentLinks = $('.localnavigationblock__sublist .localnavigationblock__item a').filter(function () {
            return $(this).attr('href').indexOf('#') > -1;
        });
        // console.log(fragmentLinks);
        $fragmentLinks.on("click", window.oneadvanced.localnavigationblock.accordionclosehandler);
        window.oneadvanced.localnavigationblock.modal.on("click", window.oneadvanced.localnavigationblock.accordionclosehandler);
    };
    window.oneadvanced.localnavigationblock.enablebacktotop = window.oneadvanced.localnavigationblock.enablebacktotop || false;
    window.oneadvanced.localnavigationblock.hasLoaded = true;
})();